import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import Button from '@components/common/button';
import { useLocales } from '@hooks/helpers/useLocales';
import { Icon } from '@components/icons';
import { useUserContext } from '@hooks/context/useUserContext';
import { EUserStatus } from '@xeppt/xeppt-sdk/types';

interface IProps {
    errors: string[];
    handleStart: () => void;
    onClose: () => void;
}

const KycErrors: FC<IProps> = ({ errors, handleStart, onClose }) => {
    const { t } = useTranslation('shufti_pro');
    const { submitLocale } = useLocales();
    const { userStatus } = useUserContext();

    return (
        <div className={styles.errors_wrapper}>
            <Typography variant="h4" className={styles.title} alignment="center">
                Identity verification failed
            </Typography>
            <Typography variant="body3" className={styles.description} alignment="center">
                We’re unable to verify your identity with your document and selfie
            </Typography>
            <div className={styles.errors_container}>
                <Typography variant="body4" weight="semibold">
                    We detected the following issues:
                </Typography>
                <div className={styles.errors_content}>
                    {errors.map((item, i) => (
                        <div key={i}>
                            <Icon width={20} height={20} name="filed_close" />
                            <Typography variant="body4">{t(item)}</Typography>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.actions}>
                <Button size="medium" variant="outlined-primary" onClick={onClose}>
                    {submitLocale('cancel')}
                </Button>
                {userStatus === EUserStatus.UNVERIFIED && (
                    <Button size="medium" variant="primary" onClick={handleStart}>
                        {submitLocale('try_again')}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default KycErrors;
